// This window-resize.js file exists to make a better-than-normal resize listener available. It does its magic via requestAnimationFrame.
// If/when you need to listen for window resizing, use it like so:
// window.addEventListener('resizeViaRAF', [your function here], false);

export default function WindowResize() {

  var running = false;

  function doItViaRAF() {

    if (running) {return;}

    running = true;

    requestAnimationFrame(function() {
      window.dispatchEvent(new CustomEvent('resizeViaRAF'));
      running = false;
    });

  }

  window.addEventListener('resize', doItViaRAF);

}
